import { memo, useState } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';
import Collapse from '../Collapse';

function formatAmount(n) {
  if (!n && n !== 0) return '';
  const num = Number(n);
  if (num >= 100000) return `${num / 100000}L`;
  if (num >= 1000) return `${num / 1000}K`;
  return String(num);
}

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}

// book hamesha visible: 0 pe book-black, minus red / plus green
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

const ARROW = 'https://wver.sprintstaticdata.com/v230/static/front/img/arrow-down.svg';

// Ball By Ball — reference: market-6 ball-by-ball, header pe collapse toggle
// (#market-runs) + arrow. 9 back-only selections (0/1/2/3/4/6 Runs, Boundary,
// Wicket, Extra Runs), col-12 col-md-6 grid (mobile 1-col full-width, desktop
// 2-col). bl-box me odds + size (25K), book hamesha visible, fancy-min-max.
const BetTableBallByBall = memo(function BetTableBallByBall({ gameData, onBet, exposures }) {
  const sub = gameData?.sub ?? [];
  const [open, setOpen] = useState(true);

  return (
    <div className="market-6 ball-by-ball">
      <div className="bet-table">
        <div
          data-toggle="collapse"
          data-target="#market-runs"
          aria-expanded={open ? 'true' : 'false'}
          className={`bet-table-header${open ? '' : ' collapsed'}`}
          onClick={() => setOpen((v) => !v)}
        >
          <div className="nation-name">
            <span title="Runs">
              <a href="#" title="" onClick={(e) => e.preventDefault()}><img src={ARROW} className="mr-1" /></a>
              {'\n          Runs\n        '}
            </span>
          </div>
        </div>
        {/* Runs header slides the body shut / open like the reference (Bootstrap
            collapse animation) — flipping `show` directly snapped it instantly. */}
        <Collapse open={open} id="market-runs" className="bet-table-body container-fluid container-fluid-5">
          <div className="row row5 d-none-mobile">
            {[0, 1].map((i) => (
              <div key={i} className="col-12 col-md-6">
                <div className="fancy-tripple">
                  <div className="bet-table-row">
                    <div className="nation-name"></div>
                    <div className="back bl-title back-title">Back</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="row row5">
            {sub.map((item, i) => {
              const suspended = isSusp(item);
              const b = item?.b ?? item?.b1 ?? '';
              const bs = item?.bs ?? item?.bs1 ?? '';
              const min = item?.min ?? '';
              const max = item?.max ?? '';
              const book = roundBook(exposures?.[`sid:${item?.sid}`] ?? exposures?.[item?.nat] ?? 0);
              return (
                <div key={item?.sid ?? i} className="col-12 col-md-6">
                  <div className="fancy-tripple">
                    <div className="bet-table-mobile-row d-none-desktop">
                      <div className="bet-table-mobile-team-name">
                        <span>{item?.nat ?? ''}</span>
                        {' '}
                        <span className={bookCls(book)}>{fmtBook(book)}</span>
                      </div>
                    </div>
                    <div className="bet-table-row">
                      <div className="nation-name d-none-mobile">
                        <p>
                          {'\n                    ' + (item?.nat ?? '') + '\n                  '}
                        </p>
                        {' '}
                        <p className={`mb-0 ${bookCls(book)}`}>{fmtBook(book)}</p>
                      </div>
                      <div
                        data-title={suspended ? 'SUSPENDED' : 'OPEN'}
                        className={`bl-box back${suspended ? ' no-val suspended' : ''}`}
                        onClick={suspended ? undefined : () => onBet && onBet(item.sid, 'back', b, item)}
                      >
                        <span className="d-block odds">{suspended ? '—' : b}</span>
                        {' '}
                        {!suspended && <span className="d-block">{formatAmount(bs)}</span>}
                      </div>
                      <div className="fancy-min-max">
                        {'\n                  Min:'}
                        <span>{formatAmount(min)}</span>
                        {'\n                  Max:'}
                        <span>{formatAmount(max)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Collapse>
      </div>
    </div>
  );
});

export default BetTableBallByBall;
